module.exports = __webpack_public_path__ + "img/1kaIXK9FtRSM7DP8YmzbJTGdxCHxKIwQv.ff840a3a.png";